import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Img from 'gatsby-image'

const Container = styled.div`
  background-color: ${props => props.theme[props.fondo]};
  position: relative;
  padding: 0 ${props => props.theme.space[4]}px;
  display: flex;
  justify-content: center;
  min-height: ${props => (props.height ? `${props.height}vw` : 'none')};

  &.fondo-imagen {
    background-image: url(${props => props.imagen});
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: cover;
  }
`

const Grid = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  z-index: 2;

  ${breakpoint('tablet')`
    max-width: ${props =>
      1000 + props.theme.space[4] * props.columnSpacing * 2}px;
  `}

  & > .tarjetas-grid {
    width: inherit;
    display: inherit;
    flex-wrap: inherit;
  }
`

const Imagen = ({ imagen }) => (
  <Img
    fluid={imagen}
    style={{
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      zIndex: 1,
    }}
  />
)

export default ({
  children,
  fondo,
  imagen,
  height,
  columnSpacing = 1,
  rowSpacing = 1,
}) => {
  const backgroundImage = typeof imagen === 'string' ? imagen : null

  return (
    <Container
      fondo={fondo}
      imagen={backgroundImage}
      className={typeof imagen === 'string' && 'fondo-imagen'}
      rowSpacing={rowSpacing}
      height={height}
    >
      <Grid columnSpacing={columnSpacing}>{children}</Grid>
      {typeof imagen === 'object' && <Imagen imagen={imagen} />}
    </Container>
  )
}
